import { render, staticRenderFns } from "./commonDialog.vue?vue&type=template&id=2d8174ba&scoped=true"
import script from "./commonDialog.vue?vue&type=script&lang=js"
export * from "./commonDialog.vue?vue&type=script&lang=js"
import style0 from "./commonDialog.vue?vue&type=style&index=0&id=2d8174ba&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8174ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/ng-cash-center-h5-uat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d8174ba')) {
      api.createRecord('2d8174ba', component.options)
    } else {
      api.reload('2d8174ba', component.options)
    }
    module.hot.accept("./commonDialog.vue?vue&type=template&id=2d8174ba&scoped=true", function () {
      api.rerender('2d8174ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonDialog.vue"
export default component.exports